export const BP_BOOTSTRAP_LG = '(min-width: 992px)';
export const BP_REPORT_DESKTOP = '(min-width: 800px)';
